export default __webpack_public_path__ + "static/media/milestone 500.c07ee94b.svg";